// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__jRBVu","title":"FrontImage_title__bTQhX"};